import { useState, useEffect, useRef } from "react";
import { getCities } from "../../../service/api";

function About() {

  return (
    <section className="whatisAstro pt-50 pb-50 bg1">
        <div className="site-width">
            <div className="whatastroWrap">
                <div className="row align-item-center">
                    <div className="col-md-5">
                        <div className="imgSec">
                            <img src={`${process.env.PUBLIC_URL}/assets/img/other/about-img.jpg`} alt="img"/>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="halfContent right">
                            <div className="textWrapper">
                                <h5>Find reliable, on-demand help — anytime you need it.</h5>
                                <h2>Hire Hourly talent , Fast and Easya</h2>
                                <p>
                                    Running a business means things can change fast — and when they do, you need reliable people who can step in right away. Hourlee connects you instantly with skilled, pre-verified talent ready for hourly work. Whether it’s short shifts, peak-hour demand, or last-minute support, we help you hire quickly and efficiently — without the hassle of long-term commitments
                                </p>
                                <div className="whyFeatures mt-3">
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Post Jobs in Minutes: Create and publish hourly job listings quickly.</h6>
                                    </div>
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Access Verified Talents: Connect with trusted, pre-screened candidates.</h6>
                                    </div>
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Real-Time Hiring: Get applications instantly and hire on the go.</h6>
                                    </div>
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Flexible Scheduling: Hire talents for a few hours, a day, or longer.</h6>
                                    </div>
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Cost-Effective Staffing: Pay only for the time worked — no overhead.</h6>
                                    </div>
                                    <div className="whyfeatCard">
                                        <img src={`${process.env.PUBLIC_URL}/assets/img/icons/check.svg`} alt="icon" style={{width: "18px"}}/>
                                        <h6>Ratings & Reviews: View feedback from previous employers to hire confidently.</h6>
                                    </div>
                                </div>
                            </div>
                            <a href="/employer/login" className="ctabtn button mt-4">Register <i className="fa-solid fa-arrow-right"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  );
}

export default About;
